import { StyleRules } from '@material-ui/core/styles';
import { ChipClassKey } from '@material-ui/core/Chip';

import { core as theme } from '../styles/core';

export const MuiChip: Partial<StyleRules<ChipClassKey>> = {
  root: {
    backgroundColor: theme.palette.grey.A200,
    borderRadius: theme.spacing(0.5),
    color: 'inherit',
    height: 'unset',
    padding: theme.spacing(0.25, 0),
    ...theme.typography.subtitle1,
  },
  icon: {
    color: 'inherit',
  },
  iconSmall: {
    width: '1em',
    height: '1em',
  },
  label: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    '.MuiChip-icon + &': {
      padding: '0 4px 0 8px',
    },
  },
  colorPrimary: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.lightest,
  },
  clickable: {
    '&:focus': {
      backgroundColor: theme.palette.grey.A400,
    },
    '&:hover': {
      backgroundColor: theme.palette.grey.A400,
    },
    '&:active': {
      boxShadow: 'none',
    },
  },
  sizeSmall: {
    height: 'unset',
    ...theme.typography.overline,
  },
};
